export const getFloatVal = (value: any) => {
  const floatValueArr = value?.match(/[+-]?\d+(\.\d+)?/g);
  const floatValue = floatValueArr && floatValueArr?.length > 0 ? floatValueArr[0] : '0';
  return floatValue !== null ? parseFloat(parseFloat(floatValue)?.toFixed(2)) : 0;
};
